export default "__VITE_ASSET__JKK$VOUq__"